import React from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import BreadcrumbContainer from "../../app/common/breadcrumb/BreadcrumbContainer";
import ListClients from "./clients/ListClients";

interface IProps {
  sections: any[];
}

const DashboardClient: React.FC<IProps> = ({ sections }) => {
  const navigate = useNavigate();

  document.title = "Mis clientes";

  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Mis clientes" sections={sections} />
      <Segment >
        <Button
          onClick={() => navigate(`/home/Client/DashboardNewClient/${null}`)}
          color="blue"
        >
          <Icon name="add user" /> Nuevo Cliente
        </Button>
        <br />
        <br />
        <ListClients />
      </Segment>
    </div>
  );
};

export default observer(DashboardClient);